<router-outlet></router-outlet>
<a
  href="https://wa.me/+260768630577?text=Hello,%20I%20want%20a%20loan"
  class="whatsapp-float"
  target="_blank"
  rel="noopener noreferrer"
>
  <img src="assets/images/whatsapp-icon.png" alt="WhatsApp" />
</a>
